import { Directive } from '@angular/core';
/**
  * @name Avatar
  * @module ionic
  * @description
  * An Avatar is a component that creates a circular image for an item.
  * Avatars can be placed on the left or right side of an item with the `item-start` or `item-end` directive.
  * @see {@link /docs/components/#avatar-list Avatar Component Docs}
 */
var Avatar = (function () {
    function Avatar() {
    }
    Avatar.decorators = [
        { type: Directive, args: [{
                    selector: 'ion-avatar'
                },] },
    ];
    /** @nocollapse */
    Avatar.ctorParameters = function () { return []; };
    return Avatar;
}());
export { Avatar };
//# sourceMappingURL=avatar.js.map


// WEBPACK FOOTER //
// avatar.ts